import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/ContentService';
import { ContentRepository } from '~repositories/ContentRepository';
import { ContentState } from '~exported/content-block/ContentBlock';
import { ELCLogger, TriggerType } from '@estee/elc-logging';

const { name, version } = __serviceInfo__;

export class LoadContentUseCase {
    private nid: number;
    private contentRepository: ContentRepository;
    private logger: ELCLogger;
    private state?: ContentState;

    constructor(nid: number, state?: ContentState) {
        this.nid = nid;
        this.state = state;
        this.contentRepository = diContainer.get(serviceNames.contentRepository);
        this.logger = diContainer.get(serviceNames.logger);
    }

    public execute = async () => {
        try {
            const content = this.state && this.state.content.get(this.nid);
            content
                ? this.contentRepository.setContent(content)
                : await this.contentRepository.loadContentData(this.nid);
        } catch (error) {
            this.logger.error({
                triggerType: TriggerType.render,
                message: error.message,
                payload: {
                    error,
                    serviceName: name,
                    serviceVersion: version
                }
            });
        }
    };
}
